"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPrettyFractionsToText = void 0;
const replaceAll_1 = require("../replaceAll");
const isDigit = (c) => !isNaN(parseInt(c, 10));
exports.addPrettyFractionsToText = (s) => {
    const words = s.split(" ");
    let newStr = "";
    words.forEach((word, i) => {
        const maybeFraction = word.slice(0, 3);
        const isLongFraction = word[3] && "0123456789".includes(word[3]);
        const shortFractionNoSpace = !isLongFraction && maybeFraction in replaceAll_1.textToFraction;
        if (word in replaceAll_1.textToFraction || shortFractionNoSpace) {
            if (i !== 0) {
                const previousWord = words[i - 1];
                if (!isDigit(previousWord.charAt(previousWord.length - 1))) {
                    newStr += " ";
                }
            }
            if (word in replaceAll_1.textToFraction) {
                newStr += replaceAll_1.textToFraction[word];
            }
            else {
                newStr += replaceAll_1.textToFraction[maybeFraction];
                if (word.length !== 7 || word.charAt(3) !== "-") {
                    newStr += word.slice(3);
                }
                else {
                    const maybeSecondFraction = word.slice(4);
                    if (maybeSecondFraction in replaceAll_1.textToFraction) {
                        newStr += "-" + replaceAll_1.textToFraction[maybeSecondFraction];
                    }
                    else {
                        newStr += word.slice(3);
                    }
                }
            }
        }
        else {
            if (i !== 0) {
                newStr += " ";
            }
            newStr += word;
        }
    });
    return newStr;
};
//# sourceMappingURL=index.js.map